// Shared password policy helpers for consistent UX across entry points

export const PASSWORD_POLICY_TEXT = 'Min 8 chars: 1 uppercase, 1 lowercase, 1 number, 1 special character. Cannot reuse last 5 passwords';

export const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export function getPasswordPolicyError(password) {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  if (!strongPasswordRegex.test(password)) {
    return 'Password must include 1 uppercase, 1 lowercase, 1 number, and 1 special character';
  }
  return '';
}
